'use client';

import { DeliveryTracking } from '@commerce-order-webcomponents/ui';
import { MobileTopHeader } from '@commerce-webcomponents/ui';
import { useNextgenRouter, useTranslation } from '@nextgen-web-framework/all';
import styles from './DeliveryTrackingPage.module.scss';
import Layout from 'app/components/Layout/Layout';
import { BasePageProps } from 'types/common';

export default function DeliveryTrackingPage({ data }: BasePageProps) {
  const t = useTranslation();
  const router = useNextgenRouter();
  const header = data?.layout?.header;
  const footer = data?.layout?.footer;
  const cmsDeliveryTracking = data?.delivery_tracking_faq?.[0];
  const orderId = router?.params?.orderId;
  const backButtonClick = () => {
    router.back();
  };
  return (
    <>
      <Layout hasTopMobileHeader={false} header={header} hideLocationSelector footer={footer}>
        <MobileTopHeader
          titleLeftAlign
          hasProfileIcon={false}
          title={t('amshop.deliveryTracking.title')}
          onBackClick={backButtonClick}
        />
        <div className={styles['delivery-tracking-page-container']} data-testid={'delivery-tracking-page-testid'}>
          <div className={styles['delivery-tracking-title']}>{t('amshop.deliveryTracking.title')}</div>
          <DeliveryTracking deliveryTrackingCMSData={cmsDeliveryTracking} orderId={orderId?.toString()} />
        </div>
      </Layout>
    </>
  );
}
